import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import {
  GetCustomerActivityFeedOutput,
  GetCustomerActivityFeedRequestParams,
  GetOrderActivityFeedOutput,
  GetOrderActivityFeedRequestParams,
  GetTargetActivityFeedOutput,
  GetTargetActivityFeedRequestParams,
} from './activityFeed.types';

export const ACTIVITY_FEED_PATH = 'activity-feed';

export const getCustomerActivityFeed = (
  { customerId, ...params }: GetCustomerActivityFeedRequestParams,
  signal?: AbortSignal,
) =>
  restApi.get<GetCustomerActivityFeedOutput>(
    `${ACTIVITY_FEED_PATH}/customers/${customerId}`,
    params,
    {
      cancelToken: cancelTokenFromSignal(signal)?.token,
    },
  );

export const getTargetActivityFeed = (
  { targetId, ...params }: GetTargetActivityFeedRequestParams,
  signal?: AbortSignal,
) =>
  restApi.get<GetTargetActivityFeedOutput>(`${ACTIVITY_FEED_PATH}/targets/${targetId}`, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });

export const getOrderActivityFeed = (
  { orderId, ...params }: GetOrderActivityFeedRequestParams,
  signal?: AbortSignal,
) =>
  restApi.get<GetOrderActivityFeedOutput>(`${ACTIVITY_FEED_PATH}/orders/${orderId}`, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });
